import APPOINTMENT_MUTATION_TYPES from './appointment.mutation-types';
import initialState from './appointment.initial-state';
import { MapFuelTypeToInt, MapGearboxTypeToInt } from '../../components/Molecules/VehicleDataForm/VehicleDataMapping';


// Private functions
function setTireInformation(state) {
  const customerData = state.customerDataRaw;
  if (customerData.tires.length > 0) {
    // Private functions
    const setTireSize = (location, size) => {
      state.tireSizes[location].width = size.width;
      state.tireSizes[location].height = size.height;
      state.tireSizes[location].diameter = size.diameter;
      state.tireSizes[location].loadCapacity = size.loadCapacity;
      state.tireSizes[location].speedIndex = size.speedIndex;
    };

    // If one of the tires is runflat, runflat is true
    if (customerData.tires.find(t => t.runFlat)) {
      state.runFlat = true;
    }

    // Set tirelocations 0/1/2/3 -> Disabled/Not active/Active/Stock
    customerData.tires.forEach(tire => {
      const location = `t${tire.position.toLowerCase()}`;

      switch (tire.tireType) {
        case 'MS':
          state.tireLocations[location].msStock = tire.stock ? 3 : 1;
          break;
        case 'TZ':
          state.tireLocations[location].tzStock = tire.stock ? 3 : 1;
          break;
        case 'TS':
          state.tireLocations[location].tsStock = tire.stock ? 3 : 1;
          break;
        default:
          break;
      }
    });

    // Set howmany tires we have in stock
    const summerStock = customerData.tires.filter(t => t.tireType === 'TZ' && t.stock).length;
    const winterStock = customerData.tires.filter(t => t.tireType === 'MS' && t.stock).length;
    const seasonStock = customerData.tires.filter(t => t.tireType === 'TS' && t.stock).length;

    state.tireStock = {
      tz: summerStock,
      ms: winterStock,
      ts: seasonStock,
    };

    // If a stock is bigger then 4 we asume they drive a bus
    state.bodyworkType = ((summerStock > 4) ||
      (summerStock > 4) ||
      (summerStock > 4)) ?
      'bus' : 'car';

    // If we have more winter tires in stock we asume summer -> winter switch
    if (winterStock > summerStock) {
      state.tireType = 'ms';
    }

    // Set tiresizes if we know a tire on the axis
    const frontAxisCodes = ['1L1', '1R1'];
    const frontAxisTire = customerData.tires
      .find(t => frontAxisCodes
        .includes(t.position) && t.tireType === state.tireType.toUpperCase());

    if (frontAxisTire != null) {
      setTireSize('frontTire', frontAxisTire);
    }

    const backAxisCodes = ['2L2', '2L1', '2R1', '2R2'];
    const backAxisTire = customerData.tires
      .find(t => backAxisCodes
        .includes(t.position) && t.tireType === state.tireType.toUpperCase());

    if (backAxisTire != null) {
      setTireSize('backTire', backAxisTire);
    }
  }
}

function setTireSizeInformationNewTires(state, setTireType) {
  const customerData = state.customerDataRaw;

  if (customerData.tires.length > 0) {
    // Private functions
    const setTireSize = (location, size) => {
      state.tireSizes[location].width = size.width;
      state.tireSizes[location].height = size.height;
      state.tireSizes[location].diameter = size.diameter;
      state.tireSizes[location].loadCapacity = size.loadCapacity;
      state.tireSizes[location].speedIndex = size.speedIndex;
    };

    // Get howmany tires we have in stock
    const summerStock = customerData.tires.filter(t => t.tireType === 'TZ' && t.stock).length;
    const winterStock = customerData.tires.filter(t => t.tireType === 'MS' && t.stock).length;

    // If we have more winter tires in stock we asume summer -> winter switch
    if (winterStock < summerStock && setTireType) {
      state.tireType = 'ms';
    }

    // Set tiresizes if we know a tire on the axis
    const frontAxisCodes = ['1L1', '1R1'];
    const frontAxisTire = customerData.tires
      .find(t => frontAxisCodes
        .includes(t.position) && t.tireType === state.tireType.toUpperCase());

    if (frontAxisTire != null) {
      setTireSize('frontTire', frontAxisTire);
    }

    const backAxisCodes = ['2L2', '2L1', '2R1', '2R2'];
    const backAxisTire = customerData.tires
      .find(t => backAxisCodes
        .includes(t.position) && t.tireType === state.tireType.toUpperCase());

    if (backAxisTire != null) {
      setTireSize('backTire', backAxisTire);
    }
  }
}


const APPOINTMENT_MUTATIONS = {
  [APPOINTMENT_MUTATION_TYPES.SET_LANGUAGE](state, language) {
    state.language = language;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_INITIALSTATE](state, clearLicensePlate) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      if (key === 'licensePlate' || key === 'regionData' || key === 'regionCode' || key === 'searchWatch') {
        if (clearLicensePlate) {
          state[key] = s[key];
        }
      } else {
        state[key] = s[key];
      }
    });
  },
  [APPOINTMENT_MUTATION_TYPES.SET_LICENSEPLATE](state, licensePlate) {
    state.licensePlate = licensePlate;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_TIMEOFARRIVAL](state, arr) {
    state.timeOfArrival = arr;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_VEHICULETYPE](state, vehiculeType) {
    state.vehiculeType = vehiculeType;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_CAT](state, cat) {
    state.cat = cat;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_TIRELOCATION](state, changeTireLocationStateObject) {
    state.tireLocations[changeTireLocationStateObject.position][changeTireLocationStateObject
      .stockType
    ] = changeTireLocationStateObject
        .state;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_TIRETYPE](state, { tireType, setTireType }) {
    state.tireType = tireType;
    // Set default tiresize if they have stock
    if ((state.vehiculeType === 'lease' || state.vehiculeType === 'fleet') && state.serviceType === 'new-tires') {
      setTireSizeInformationNewTires(state, setTireType);
    }
  },
  [APPOINTMENT_MUTATION_TYPES.SET_BODYWORKTYPE](state, bodyworkType) {
    state.bodyworkType = bodyworkType;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_SERVICETYPE](state, serviceType) {
    state.serviceType = serviceType;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_REGION](state, region) {
    state.region = region;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_MODALTPP](state, modalState) {
    state.tppModal = modalState;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_REGIONCODE](state, code) {
    state.regionCode = code;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_RID](state, rid) {
    state.rid = rid;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_POSTALCODE](state, postalCode) {
    state.postalCode = postalCode;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_RUNFLAT](state, runFlat) {
    state.runFlat = runFlat;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_TIRESIZE](state, changeTireSizeStateObject) {
    state.tireSizes[changeTireSizeStateObject.property] = changeTireSizeStateObject
      .size;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_PERSONALDATA](state, personalDataStateObject) {
    state.personalData[personalDataStateObject.property] = personalDataStateObject.state;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_VEHICLEDATA](state, vehicleDataStateObject) {
    state.vehicleData[vehicleDataStateObject.property] = vehicleDataStateObject.state;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_REGIONDATA](state, regionDataStateObject) {
    state.regionData[regionDataStateObject.property] = regionDataStateObject.state;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_SEARCHWATCH](state, watch) {
    state.searchWatch = watch;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_DEPOT](state, depotId) {
    state.depotId = depotId;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_ADDRESS](state, addressId) {
    state.addressId = addressId;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE](state, isLoading) {
    state.status.loadingState = isLoading;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_CHASSIE](state, chassie) {
    state.chassie = chassie;
  },
  [APPOINTMENT_MUTATION_TYPES.APPEND_CUSTOMER](state, customerData) {
    // // console.log(customerData); // Reponse object getCustomer endpoint

    // -- For testing --

    // eslint-disable-next-line no-param-reassign
    // customerData.customerType = 'lease';

    // eslint-disable-next-line no-param-reassign
    // customerData.tires = [];

    // eslint-disable-next-line no-param-reassign
    // customerData.depotId = 116;

    state.customerDataRaw = customerData;

    if (customerData.customerType !== 'unknown') {
      state.licensePlate = customerData.licensePlate.toUpperCase();
    } else {
      state.licensePlate = state.licensePlate.toUpperCase();
    }

    if (customerData.address !== 'unknown') {
      state.address = customerData.address;
    }
    state.vehiculeType = customerData.customerType;

    setTireInformation(state);

    if (customerData.depotId !== 'unknown') {
      state.depotId = customerData.depotId;
    }

    if (customerData.depotIds !== 'unknown') {
      state.depotIds = customerData.depotIds;
    }

    if (customerData.depotId !== 'unknown') {
      state.favouredDepotId = customerData.depotId;
    }

    if (customerData.maintenanceDepotIds !== 'unknown') {
      state.maintenanceDepotIds = customerData.maintenanceDepotIds;
    }

    // Driver info
    if (customerData.driver != null) {
      state.personalData.title = customerData.driver.title;
      state.personalData.firstName = customerData.driver.firstName !== null ? customerData.driver.firstName : '';
      state.personalData.lastName = customerData.driver.lastName !== null ? customerData.driver.lastName : '';
      state.personalData.email = customerData.driver.email;
      state.personalData.cellphoneNumber = customerData.driver.cellphoneNumber;
      state.personalData.zipCode = customerData.driver.zipCode;
      state.personalData.city = customerData.driver.city;
      state.personalData.address = customerData.driver.address;
      state.personalData.leasingCompanyId = customerData.driver.leasingCompanyId;
      state.personalData.company = customerData.driver.company;
      state.chassie = customerData.driver.chassis;
    }

    // Vehicle info
    if (customerData.vehicle != null) {
      state.vehicleData.brand = customerData.vehicle.brand;
      state.vehicleData.model = customerData.vehicle.model;
      state.vehicleData.manufactureDate = customerData.vehicle.manufactureDate;
      state.vehicleData.gearbox = MapGearboxTypeToInt(customerData.vehicle.gearbox);
      state.vehicleData.fuel = MapFuelTypeToInt(customerData.vehicle.fuel);
    }
    // Appointment
    if (customerData.appointment != null) {
      state.appointment.depotId = customerData.appointment.depotId;
      state.appointment.dateTime = customerData.appointment.dateTime;
      state.appointment.hour = customerData.appointment.hour;
      state.appointment.date = customerData.appointment.date;
      state.appointment.addressId = customerData.appointment.addressId;

      if (state.appointment.addressId !== '' || customerData.appointment.depotId !== '') {
        state.depotId = customerData.appointment.depotId;
        state.appointment.hasAppointment = true;
        state.appointment.deliveryNote = customerData.appointment.deliveryNote;
        state.appointment.type = customerData.appointment.type;
        state.serviceType = customerData.appointment.type;
        state.tireType = customerData.appointment.type;
        state.appointment.tag = customerData.appointment.tag;
      }
    }
  },
  [APPOINTMENT_MUTATION_TYPES.APPEND_RESERVATION](state, reservation) {
    state.slotNumber = reservation.slotNumber;
    state.slotDate = reservation.date;
    state.slotHour = reservation.hour;
    state.slotDuration = reservation.duration;
  },
  [APPOINTMENT_MUTATION_TYPES.APPEND_RESERVATION_MOBILE_COMP](state, date) {
    state.slotDate = date;
  },
  [APPOINTMENT_MUTATION_TYPES.CLEAR_RESERVATION](state) {
    state.slotNumber = '';
    state.slotDate = '';
    state.slotHour = '';
  },
  [APPOINTMENT_MUTATION_TYPES.SET_STOCK](state) {
    setTireInformation(state);
  },
  [APPOINTMENT_MUTATION_TYPES.SET_HASAPPOINTMENT](state, val) {
    state.appointment.hasAppointment = val;
  },
  [APPOINTMENT_MUTATION_TYPES.CLEAR_STOCK](state) {
    state.tireStock = {
      ms: 0,
      ts: 0,
      tz: 0,
    };

    const tireLocations = ['t1l1', 't1r1', 't2l2', 't2l1', 't2r1', 't2r2'];
    const tireStockProperties = ['msStock', 'tsStock', 'tzStock'];

    tireLocations.forEach(tireLocation => {
      tireStockProperties.forEach(stockProperty => {
        state.tireLocations[tireLocation][stockProperty] = 1;
      });
    });
  },
  [APPOINTMENT_MUTATION_TYPES.SET_REMARK](state, value) {
    state.remark = value;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_COMPANY](state, value) {
    state.company = value;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_ERROR_SLOT](state, value) {
    state.status.errorSlot = value;
  },
  [APPOINTMENT_MUTATION_TYPES.CLEAR_ERROR_SLOT](state, value) {
    state.status.errorSlot = value;
  },
  [APPOINTMENT_MUTATION_TYPES.SET_ERROR](state, error) {
    state.status.error = error;
  },
};

export default APPOINTMENT_MUTATIONS;
